<template>
  <button
    class="font-button text-button text-secondary p-3 rounded border-2 border-secondary"
    :class="getBackgroundColor()"
    @click="handleClick()"
  >
    {{ text }}
    <slot v-if="text.length < 1"></slot>
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: () => {
        return ''
      }
    },
    color: {
      type: String,
      default: () => {
        return 'orange-accent-translucent'
      }
    }
  },
  methods: {
    getBackgroundColor () {
      return 'bg-' + this.color
    },
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>
